import Typography from '@material-ui/core/Typography';
import React from 'react';

function CampaignVideoFlag(props) {
  return (
    <Typography
      variant="h4"
      style={{
        fontSize: '0.6rem',
        color: props.color,
        border: `1px solid ${props.color}`,
        display: 'inline-block',
        margin: '0 0 10px 10px',
        padding: '3px 10px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...props.style,
      }}
    >
      {props.title}
    </Typography>
  );
}

export default CampaignVideoFlag;
